/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { ENDPOINT } from '../../../services/endPoints'
import { LeftSide, LoginContainer, RightSide } from '../Login/LoginStyle'
import { Box, Button, CircularProgress, Typography } from '@mui/material'
import CustomToast from '../../../components/Toast/CustomToast'
import PATH from '../../../router/params'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import useToast from '../../../hooks/useToast'
import useMasterApi from '../../../services/useMasterApi'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ChangePasswordSchema } from '../../../schemas/PasswordResetSchema'
import InputController from '../../../components/InputController/InputController'

const ChangePassword = () => {
    const navigate = useNavigate();
    const [searchParams] =useSearchParams();
    const {post: verifyToken, data: tokenData, error:tokenError, loading: tokenLoading} = useMasterApi();
    const {post, data, error, loading} = useMasterApi();
    const { toastMessage, toast, toastType, setToast, showToast } = useToast()
    const token = searchParams.get("token");
    const { handleSubmit, control, formState: {errors}, reset, watch} = useForm({
      defaultValues:{
        password: "",
        confirm_password: "",
        token: token ?  token : ""
      },
      resolver: yupResolver(ChangePasswordSchema),
    });

    const password = watch("password");
    const confirm_password = watch("confirm_password");


    useEffect(()=>{
        if(token){
          verifyToken(ENDPOINT.VALIDATE_TOKEN, {token: token})
        }
      },[])

      
    const onSubmit = async (form_data)=>{
      if(password === confirm_password){
        await post(ENDPOINT.CHANGE_PASSWORD, {password: form_data.password, token: token}); 
        reset();
      } else {
        showToast("error", "Passwords do not match");
      }
    }

     useEffect(()=>{
        if(tokenData){
          if(tokenData.success){
            showToast("success", "Token Validated Successfully")           
          }
          if(tokenError){
            showToast("error", tokenError.data.error)
            setTimeout(()=>{
                navigate(PATH.HOME, {replace: true});
            },3000)
          }
        }
      },[tokenData, tokenError])


  
    useEffect(()=>{
      if(data){
        if(data.success){
          showToast("success", "Password Reset Successfully")

          setTimeout(()=>{
            showToast("success", "You will be redirected to login page in 2 seconds...")
          },1000)
    
          setTimeout(()=>{
            navigate(PATH.HOME, {replace: true});
          },3000)
          
        }
        if(error){
          showToast("error", error.data.error)
        }
      }
    },[data, error])


  return (
    <LoginContainer>
    <RightSide>
      <Box sx={{ height:"100%", display:"flex", flexDirection: "column", width:"100%",  alignItems:"center", gap: "2rem"  }}>
      <Box component="img" src="/assets/images/logo.png" alt="Ministry of Health Logo" style={{ width: "125px", height: "96px" }}/>
      </Box>
    </RightSide>


      <LeftSide>
        <Box sx={{ height:"100%", width: "100%", position:"relative" }}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ display:"flex", flexDirection: "column", gap: "1rem", maxWidth:"550px", mx:"auto" }}>
               <Box sx={{textAlign:"center"}}>
                   <Typography variant="h1" fontWeight="bold" color={(theme)=>theme.palette.secondary.main}>
                      Create <Box sx={{display: "inline", color: (theme)=>theme.palette.aqua.main}}>Password!</Box>
                   </Typography>
            </Box> 
                    <InputController
                     name="password"
                     label="Password"
                     control={control}
                     errors={errors}
                     mainLogin
                     />

                    <InputController
                     name="confirm_password"
                     label="Confirm Password"
                     control={control}
                     errors={errors}
                     mainLogin
                     />
                <Button type="submit" disabled={loading || !!tokenError} variant="contained" fullWidth sx={{mt:2}}> {loading ? <CircularProgress/> : "Set Password"}</Button>
             </Box>
          </form>
        </Box>
      </LeftSide>
      {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </LoginContainer>
  )
}

export default ChangePassword